module.exports = " <div class=default> <h1><img src=" + require("appAsset/ic_error.png") + " alt=\"\"></h1> <p>页面找不到了....<a href=javascript:history.go(-1);>返回上一页</a></p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/appBackend/components/page/default/default.vue
// module id = 1126
// module chunks = 2